/** @jsxImportSource @emotion/react */

import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAuthPage, useSignUpAndIn } from '@hook/auth/useAuth';
import { getInitialServicePath } from '@constant/common/route-path';
import Spinner from '@design-system/spinner';
import TextButton from '@design-system/text-button';
import { ETheme } from '@datatype/type';
import * as size from '@constant/size';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

const FallbackContainer = styled.div`
  position: absolute;
  bottom: calc(0px + ${size.PAGE_PADDING});
  left: ${size.PAGE_PADDING};
  right: ${size.PAGE_PADDING};
`;

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { kind } = useParams(); // auth/callback/:kind
  const navigate = useNavigate();
  const { openSignupPage } = useAuthPage();
  const { oauthSignin } = useSignUpAndIn();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowFallback(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    (async () => {
      if (kind === 'signup') {
        const email = searchParams.get('email');
        const type = searchParams.get('type');

        if (!email) {
          console.error('email not found');
          return;
        }

        if (!type) {
          console.error('type not found');
          return;
        }

        openSignupPage(type as any, email);
        // navigate(getInitialServicePath()); // 가입 모달 표시 + 가입 완료 시 authenticationInitialize가 navigate 담당
      } else if (kind === 'signin') {
        const userKey = searchParams.get('key');
        const accessToken = searchParams.get('accessToken');
        const refreshToken = searchParams.get('refreshToken');

        if (!userKey) {
          console.error('user key not found');
          return;
        }

        if (!accessToken) {
          console.error('access token not found');
          return;
        }

        if (!refreshToken) {
          console.error('refresh token not found');
          return;
        }

        await oauthSignin(userKey, accessToken, refreshToken);
        // navigate(getInitialServicePath()); // authenticationInitialize가 navigate 담당
      } else if (kind === 'mail') {
        // navigate(NEWSLETTER_PATH);
      } else {
        navigate(getInitialServicePath());
      }
    })();
  }, []);

  return (
    <Wrapper>
      <Spinner size='40px' />
      {showFallback && (
        <FallbackContainer>
          <TextButton
            theme={ETheme.BROWN}
            kind={'filled'}
            size={'medium'}
            shape='pill'
            width={'100%'}
            text={'홈으로 가기'}
            handleClick={() => navigate(getInitialServicePath())}
          />
        </FallbackContainer>
      )}
    </Wrapper>
  );
};

export default OAuthCallback;
